export default {

  // 产品分类列表
  getCourseList(params, success) {
    Request.GET(`/course/${params.facultyId}`, null, response => success(response));
  },

  // 产品分类详情
  getCourseDetail(params, success) {
    Request.GET(`/commodity/course/${params}`, null, response => success(response));
  },

  // 院系列表
  getFacultyList(params, success) {
    Request.GET('/faculty', params, response => success(response));
  },

  // 产品列表
  getEnrollmentList(params, success) {
    Request.GET('/enrollment', params, response => success(response));
  },

  // 产品详情
  getEnrollmentDetail(params, success) {
    Request.GET(`/enrollment/${params}`, null, response => success(response));
  },

  // 提交报名申请
  submitJoin(params, success) {
    Request.POST('/enrollment/submit', params, response => success(response));
  },

  // 核对报名信息
  getEnrollmentCheckDetail(params, success) {
    Request.GET(`/enrollment/check/${params}`, null, response => success(response));
  },

  // 分组树
  getMenuList(params, success) {
    Request.GET('/faculty/tree', params, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/courseApi.js